import { render, staticRenderFns } from "./InquiryDetail.vue?vue&type=template&id=55988786&scoped=true&"
import script from "./InquiryDetail.vue?vue&type=script&lang=js&"
export * from "./InquiryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55988786",
  null
  
)

component.options.__file = "InquiryDetail.vue"
export default component.exports